module.exports = __webpack_public_path__ + "static/media/Pin.5d6b1a2a.svg";